module.exports = __webpack_public_path__ + "static/carto-13893a75c6326664669241703c187b99.png";